// SEO helper utilities for SPA per-page meta tag updates

export function updateMeta(name, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`)
  if (el) {
    el.setAttribute('content', content)
  } else {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    el.setAttribute('content', content)
    document.head.appendChild(el)
  }
}

export function updateLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`)
  if (el) {
    el.setAttribute('href', href)
  } else {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    el.setAttribute('href', href)
    document.head.appendChild(el)
  }
}